import * as types from '../actions/actionTypes';
import initialState from './initialState';
import _ from 'lodash';

export default function taskReducer(state = initialState.tasks, action) {
    switch (action.type) {
        case types.GET_MY_TASKS_SUCCESS:
            return action.tasks;

        case types.STORE_TASK_SUCCESS:
            return [
                Object.assign({}, action.task),
                ...state
            ];

        case types.UPDATE_TASK_SUCCESS:
            return updateTask(state, action.task);

        case types.DELETE_TASK_SUCCESS:
            return deleteTask(state, action.task);

        default:
            return state;
    }
}

function updateTask(state, task) {
    const index = _.findIndex(state, {id: task.id});
    let newState = _.clone(state);
    newState = _.reject(newState, {id: task.id});
    newState.splice(index, 0, task);
    return newState;
}

function deleteTask(state, task) {
    let newState = _.clone(state);
    newState = _.reject(newState, {id: task.id});
    return newState;
}


/** WEBPACK FOOTER **
 ** ./src/reducers/taskReducer.js
 **/